import React from 'react';
import ReactDOM from 'react-dom';
import ShoppingApp from './components/ShoppingApp.js';
import 'normalize.css/normalize.css';
import './styles/styles.scss';

ReactDOM.render(<ShoppingApp />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/app.js